/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';

import confirmIcon from '@ba-ui-toolkit/ba-graphics/dist/icons-js/checkmark--filled_16.js';
import currentIcon from '@ba-ui-toolkit/ba-graphics/dist/icons-js/current_16.js';
import incompleteIcon from '@ba-ui-toolkit/ba-graphics/dist/icons-js/incomplete_16.js';

import TruncatedText from '@ba-ui-toolkit/truncatedtext';
import SVGIcon from '@ba-ui-toolkit/svgicon';

import styles from './WizardStepIndicator.scss';

const iconMap = {
	COMPLETED: confirmIcon,
	CURRENT: currentIcon,
	INCOMPLETE: incompleteIcon,
};

export const WizardStepIndicator = props => {
	const icon = iconMap[props.step] || iconMap.INCOMPLETE;
	const sanitizedClassName = styles.wizardStepIndicatorClassName.replace(/"/g, '');

	return (
		<div className={sanitizedClassName} data-tid="wizard-step-indicator">
			<SVGIcon iconId={icon.id} />
			<TruncatedText value={props.label} />
		</div>
	);
};

WizardStepIndicator.propTypes = {
	label: PropTypes.string.isRequired,
	step: PropTypes.string,
};
